import React, { useEffect } from 'react';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { useKeycloak } from 'app/modules/keycloak/keycloak';
import { Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

interface CustomLoginProps {
  isAuthenticated?: boolean;
  hasAnonymousRole?: boolean;
}

const CustomLogin = (props: CustomLoginProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log(props.isAuthenticated);
    console.log(props.hasAnonymousRole);

    if (props.isAuthenticated && !props.hasAnonymousRole) {
      localStorage.setItem('CUSTOM_LOGIN', "true");
      navigate('/');
    }
  }, [props.isAuthenticated, props.hasAnonymousRole]);

  const handleLogin = () => {
    useKeycloak()?.login();
  };

  return (
    <div className="container-fluid view-container bg-white justify-content-center">
      <Row>
        <Col className={'d-flex justify-content-center mb-5'}>
          <img style={{ maxWidth: '360px', minHeight: '360px' }} src={`content/images/homepage.png`} />
        </Col>
      </Row>
      <Row>
        <Col className={'d-flex justify-content-center mb-2'}>
          <span className={'h6'}>MINISTARSTVO PROSTORNOGA UREĐENJA, GRADITELJSTVA I DRŽAVNE IMOVINE</span>
        </Col>
      </Row>
      <Row>
        <Col className={'d-flex justify-content-center mb-2'}>
          <h3>Dobro došli na stranicu na koju možda i niste trebali doći.</h3>
        </Col>
      </Row>
      <Row className={'d-flex justify-content-center'} style={{ marginRight: '15%', marginLeft: '15%' }}>
        <Col style={{ color: '#888c94' }} className={'d-flex justify-content-center text-center mb-5 text-gray'}>
          <span>
            Ova usluga omogućava loginanje u sustav preko keycloaka. Za sve nejasnoće ili poteškoće prilikom prijave, molimo Vas obratite se
            korisničkoj službi na adresi: <a href={'https://www.uprava-vodovoda.com/arhiva.php'}>Korisnička služba i družba</a>.
          </span>
        </Col>
      </Row>
      <Row>
        <Col className={'d-flex justify-content-center'}>
          <Button onClick={handleLogin} label={'Login'} size={'lg'} color={'info'} />
        </Col>
      </Row>
    </div>
  );
};

export default CustomLogin;
